import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const accountsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'fullNumber',
    label: 'Acc. No. ',
  },
  {
    name: 'pspIntegrationAccountStatus',
    label: 'Vault Status',
    hidden: true,
  },
  {
    name: 'realNumberOrIban',
    label: 'Real acc numb / IBAN',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'categoryId',
    label: 'Acc type',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'isDefaultForExternalOperations',
    label: 'Default for external operations',
  },
  {
    name: 'caspId',
    label: 'CASP',
  },
  {
    name: 'active',
    label: 'Status',
    filterModalPlacement: 'right',
  },
];

export const accountsColumnsLabels = {
  active: 'Status',
  description: 'Description',
  fullNumber: 'Acc. No.',
};

export const acountsDefaultSorter = {};

export const accountsSchema = {
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  fullNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'description',
    type: FilterType.TEXT,
    placeholder: 'Enter description...',
  },
  {
    name: 'fullNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter Acc No...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];
